import { FetchQuoteResponseData } from '@features/invoices/query-api'

import apiZervant from '../../utils/apiZervant'

export const fetchQuote = async (quoteId: string) => {
  return apiZervant.restInvoice.get<FetchQuoteResponseData>(`/v1/estimates/${quoteId}`)
}

type FetchQuoteHtmlResponse = string

export const fetchQuoteHtml = async (quoteId: string) => {
  return apiZervant.restInvoice.get<FetchQuoteHtmlResponse>(`/estimates/${quoteId}/html`)
}
